import { FuelButton, FuelIcon, FuelTypography } from '@frete.com/fuel-react'
import * as Styled from './styled'
import { useRequest } from 'ahooks'
import { Phone } from '~services'
import { formatCellphone } from '~utils/format'
import { Modal } from '~components'
import { useState } from 'react'
import { Cellphone } from '~utils/types'
import { useNavigate } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
import { usePath } from '~hooks'

function ContactNumbers() {
  const [modalCantAddNumberOpen, setModalCantAddNumberOpen] = useState(false)
  const [modalDeleteOpen, setModalDeleteOpen] = useState(false)
  const [modalCantDeleteOpen, setModalCantDeleteOpen] = useState(false)
  const [selectedCellphone, setSelectedCellphone] = useState<Cellphone>()
  const { data: cellphonesResponse, loading: loadingCellphones } = useRequest(Phone.list)
  const { runAsync: deleteCellphone, loading: removingCellphoneLoading } = useRequest(Phone.remove, { manual: true })
  const navigate = useNavigate()
  const path = usePath()

  function handleCloseModalCantAddNumberOpen() {
    setModalCantAddNumberOpen(false)
  }

  function handleCloseModalCantDelete() {
    setModalCantDeleteOpen(false)
  }

  function handleClickAddNumber() {
    if (cellphonesResponse?.data?.length === 3) setModalCantAddNumberOpen(true)
    else navigate('/adicionar-celular', { state: { previousPath: path } })
  }

  function handleCloseDeleteModal() {
    setModalDeleteOpen(false)
  }

  async function handleConfirmDeleteModal() {
    await deleteCellphone(selectedCellphone.id)
    navigate('/numero-sucesso', { state: { previousPath: path } })
  }

  function handleClickDelete(cellphone: Cellphone) {
    if (cellphonesResponse?.data?.length === 1) setModalCantDeleteOpen(true)
    else {
      setModalDeleteOpen(true)
      setSelectedCellphone(cellphone)
    }
  }

  return (
    <>
      <Styled.Title>Números de contato</Styled.Title>
      <Styled.Subtitle displayInline>Você pode ter até 3 números de celular.</Styled.Subtitle>
      <Styled.Line />
      <div>
        {loadingCellphones ? (
          <Skeleton
            baseColor="#F4F5F7"
            highlightColor="#d7dde7"
            count={3}
            height={50}
            borderRadius={30}
            style={{ marginBottom: '20px', marginTop: '20px' }}
            containerTestId="skeleton-contact-numbers"
          />
        ) : (
          cellphonesResponse?.data?.map?.((cellphone) => (
            <Styled.Cellphone>
              <Styled.Number data-testid={`cellphone-${cellphone.number}`}>
                <FuelIcon name="phone" size="medium" />
                <FuelTypography size="body-md" weight="medium">
                  {formatCellphone(cellphone)}
                </FuelTypography>
              </Styled.Number>
              <FuelButton variant="secondary" trailingIcon="delete" onClick={() => handleClickDelete(cellphone)}>
                Excluir
              </FuelButton>
            </Styled.Cellphone>
          ))
        )}
      </div>
      <Styled.ConfirmButton onClick={handleClickAddNumber}>Adicionar número</Styled.ConfirmButton>
      <Modal
        open={modalCantAddNumberOpen}
        onConfirm={handleCloseModalCantAddNumberOpen}
        onClose={handleCloseModalCantAddNumberOpen}
        title="Não foi possível adicionar o número"
        content="Você só pode ter até 3 números de celular cadastrados. Para adicionar um novo, exclua pelo menos um telefone existente."
        buttonLabel="Ok, entendi"
      />
      <Modal
        open={modalCantDeleteOpen}
        onConfirm={handleCloseModalCantDelete}
        onClose={handleCloseModalCantDelete}
        title="Não foi possível excluir o número"
        content="Você precisa ter pelo menos um número de celular cadastrado na Fretebras."
        buttonLabel="Ok, entendi"
      />
      <Modal
        open={modalDeleteOpen}
        onConfirm={handleConfirmDeleteModal}
        onClose={handleCloseDeleteModal}
        onCancel={handleCloseDeleteModal}
        title="Excluir número?"
        content={`O celular ${formatCellphone(selectedCellphone)} não vai mais aparecer no seu perfil.`}
        buttonLabel="Excluir"
        confirmButtonLoading={removingCellphoneLoading}
        buttonCancelLabel="Cancelar"
      />
    </>
  )
}

export default ContactNumbers
